import styled from "styled-components";
import { getHexOpacity } from "../../../../../utils/pipes";

export const ContentExtra = styled.div`
  padding: 20px;
  overflow: auto;
  padding: 20px;
  display: flex;
  height: 100%;
  box-sizing: border-box;
  .no-content {
    margin: auto;
    justify-items: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    &__img {
      width: 250px;
    }
    &__text {
      font-family: Nunito Sans;
      font-size: 17px;
      color: #3E3E5B;
      margin-top: 30px;
    }
  }
  .extra-item {
    display: flex;
    align-items: center;
    padding: 10px 0px;
    border-bottom: 1px solid #EFEFF9;
    margin-bottom: 10px;
    .symbol {
      color: #707582;
      font-family: Nunito Sans Bold;
      font-size: 20px;
      padding: 0 5px;
      margin-right: 10px;
    }
    .extra-data {
      .extra-title {
        font-family: Nunito Sans;
        font-size: 17px;
        margin-bottom: 10px;
      }
      .extra-description {
        font-family: Nunito Sans;
        font-size: 14px;
        color: #3E3E5B;
      }
    }
  }
`;